//@ts-check
import { authHeader, config, handleResponse } from '../../../_helpers';


async function getAll(requestData) {
    const page = (requestData && requestData.page) || 0;
    const pageSize = (requestData && requestData.pageSize) || 10;
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };
    return fetch(
        `${config.apiUrl}/folderWorkflow/getAll?page=${page}&pageSize=${pageSize}`,
        requestOptions
    ).then(handleResponse);
}

async function getByDirectoryId(directoryId) {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };
    return fetch(
        `${config.apiUrl}/folderWorkflow/getByDirectoryId?directoryId=${directoryId}`,
        requestOptions
    ).then(handleResponse);
}

async function getFolderWorkflows() {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };
    return fetch(
        `${config.apiUrl}/folderWorkflow/getFolderWorkflows`,
        requestOptions
    ).then(handleResponse);
}

async function save(requestData) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData)
    };
    return fetch(`${config.apiUrl}/folderWorkflow/save`, requestOptions).then(handleResponse);
}

async function validation(requestData) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData)
    };
    return fetch(`${config.apiUrl}/folderWorkflow/validation`, requestOptions).then(handleResponse);
}

async function update(requestData) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData)
    };
    return fetch(`${config.apiUrl}/folderWorkflow/update`, requestOptions).then(handleResponse);
}

async function remove(requestData) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData)
    };
    return fetch(`${config.apiUrl}/folderWorkflow/delete`, requestOptions).then(handleResponse);
}

async function getForFolder(directoryId) {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };
    return fetch(
        `${config.apiUrl}/folderWorkflow/getForFolder?directoryId=${directoryId}`,
        requestOptions
    ).then(handleResponse);
}

export const folderWorkflowService = {
    getAll,
    getByDirectoryId,
    getFolderWorkflows,
    save,
    update,
    remove,
    getForFolder,
    validation
};
